import React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ESRFieldProps } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";

export const ESRBooleanNAField = (props: ESRFieldProps) => {
	const { question_id, locked, hint_value } = props;
	const [value, setValue] = useRemoteField(question_id);

	const handleChange = (newVal: string) => {
		setValue(newVal, locked === -1);
	};
	return (
		<RadioGroup
			row value={value ?? ""}
			onChange={(e) => handleChange(e.target.value)}>
			<FormControlLabel
				disabled={locked > 0}
				value="True"
				control={<Radio />}
				label="Yes"
				sx={{
					color:
						hint_value === "True" && value === ""
							? "secondary.main"
							: "inherit",
					"& .MuiTypography-root": {
						color:
							hint_value === "True" && value === ""
								? "secondary.main"
								: "inherit",
					},
				}}
			/>
			<FormControlLabel
				disabled={locked > 0}
				value="False"
				control={<Radio />}
				label="No"
				sx={{
					color:
						hint_value === "False" && value === ""
							? "secondary.main"
							: "inherit",
					"& .MuiTypography-root": {
						color:
							hint_value === "False" && value === ""
								? "secondary.main"
								: "inherit",
					},
				}}
			/>
			<FormControlLabel
				disabled={locked > 0}
				value="NA"
				control={<Radio />}
				label="N/A"
				sx={{
					color:
						hint_value === "NA" && value === "" ? "secondary.main" : "inherit",
					"& .MuiTypography-root": {
						color:
							hint_value === "NA" && value === ""
								? "secondary.main"
								: "inherit",
					},
				}}
			/>
		</RadioGroup>
	);
};